export default {
    item: {},
    items: [],
    total: 0,
    isFetching: true,
    isFailed: false
};